<template>
  <Modal class="dea-modal-delete-school dea-modal--no-footer" :visible="visible" @modalClose="$emit('close-modal')">
    <template slot="title">
      Non insegni più in questa scuola?
    </template>
    <template slot="content">
      <div class="dea-modal-delete-school__buttons dea-modal-buttons">
        <Buttons class="dea-button--large" @click="deleteSchool">No, rimuovila</Buttons>
        <Buttons class="dea-button--medium dea-button--outline" @click="$emit('close-modal')">Annulla</Buttons>
      </div>
    </template>
  </Modal>
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapActions } from "vuex";
import Buttons from "@/components/elements/Buttons";
import Modal from "@/components/patterns/Modal";
import Schools from "../../../clients/schools";

export default {
  name: "DeleteSchoolModal",
  components: { Buttons, Modal },
  props: {
    schoolToDelete: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions(["fetchUser"]),
    async deleteSchool() {
      document.querySelector("body").classList.add("wait");
      await this.removeSchool(this.schoolToDelete);
      await this.fetchUser(true);
      document.querySelector("body").classList.remove("wait");
      this.$emit("close-modal");
    },
    async removeSchool(school) {
      try {
        await Schools.deleteSchool(this.$root.config, school, this.user.id);
      } catch (e) {
        Sentry.captureException(e);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-modal-delete-school {
  &__buttons {
    @include media("<=s") {
      flex-direction: column;

      button {
        margin: $space-base 0;
      }
    }
  }
}
</style>
